module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MCA4MCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ViNTUwNTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnBsdXMtb3JhbmdlPC90aXRsZT48cG9seWdvbiBjbGFzcz0iYSIgcG9pbnRzPSI4MCAzNCA0NiAzNCA0NiAwIDM0IDAgMzQgMzQgMCAzNCAwIDQ2IDM0IDQ2IDM0IDgwIDQ2IDgwIDQ2IDQ2IDgwIDQ2IDgwIDM0Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/plus-orange.svg
// module id = SQat
// module chunks = 0